<template>
  <div class="corporate-portrait">
    <div class="corporate-portrait-title">
      <marquee width="100%" height="100%" direction="left" behavior="scroll" scrollamount="2" scrolldelay="1" loop="scroll" id="top-marquee">
        <div>{{enterpriseData.name || '企业画像'}}</div>
      </marquee>
    </div>

    <div class="corporate-portrait-main">
      <!--左侧企业数据-->
      <div class="corporate-portrait-main-left">
        <div class="corporate-portrait-main-title-line">企业基本信息</div>
        <div class="corporate-portrait-main-left-table">
          <div class="corporate-portrait-main-left-table-line" style="border-top: 0;">
            <div class="corporate-portrait-main-left-table-line-tip">企业名称</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.name || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">法定代表人</div>
            <div class="corporate-portrait-main-left-table-line-info corporate-portrait-main-left-table-line-border-right">{{enterpriseData.represent || '无'}}</div>
            <div class="corporate-portrait-main-left-table-line-tip">注册资本</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.registerMoney || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">所属地区</div>
            <div class="corporate-portrait-main-left-table-line-info corporate-portrait-main-left-table-line-border-right">{{enterpriseData.province}}{{enterpriseData.city}}{{enterpriseData.region}}</div>
            <div class="corporate-portrait-main-left-table-line-tip">经营状态</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.status || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">成立日期</div>
            <div class="corporate-portrait-main-left-table-line-info corporate-portrait-main-left-table-line-border-right">{{enterpriseData.buildDate || '无'}}</div>
            <div class="corporate-portrait-main-left-table-line-tip">住户类型</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.type || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">统一社会信用代码</div>
            <div class="corporate-portrait-main-left-table-line-info corporate-portrait-main-left-table-line-border-right">{{enterpriseData.unicomCode || '无'}}</div>
            <div class="corporate-portrait-main-left-table-line-tip">纳税人识别号</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.taxpayerNo || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">注册号</div>
            <div class="corporate-portrait-main-left-table-line-info corporate-portrait-main-left-table-line-border-right">{{enterpriseData.registerNo || '无'}}</div>
            <div class="corporate-portrait-main-left-table-line-tip">组织机构代码</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.organizationCode || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">联系电话</div>
            <div class="corporate-portrait-main-left-table-line-info corporate-portrait-main-left-table-line-border-right">{{enterpriseData.contractPhone || '无'}}</div>
            <div class="corporate-portrait-main-left-table-line-tip">参保人数</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.contributeNum || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">所属行业</div>
            <div class="corporate-portrait-main-left-table-line-info corporate-portrait-main-left-table-line-border-right">{{enterpriseData.involve || '无'}}</div>
            <div class="corporate-portrait-main-left-table-line-tip">经营范围</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.businessScope || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">企业公示的地址</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.address || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line">
            <div class="corporate-portrait-main-left-table-line-tip">企业公示的邮箱</div>
            <div class="corporate-portrait-main-left-table-line-info">{{enterpriseData.email || '无'}}</div>
          </div>
          <div class="corporate-portrait-main-left-table-line" style="flex: 1;">
            <div class="corporate-portrait-main-left-table-line-tip">企业公示的网址</div>
            <div class="corporate-portrait-main-left-table-line-info">
              <a :href="enterpriseData.website" target="_blank" class="enterprise-big-data-info" style="color: #31BEFB;">{{enterpriseData.website}}</a>
            </div>
          </div>
        </div>
      </div>

      <!--右侧统计数据-->
      <div class="corporate-portrait-main-right">
        <!--电控-->
        <common-line style="z-index: 1000;width: 50%;" lineId='electricRecordLine' :height='"5rem"' lineTitle='企业用电数据' :titleStyle="commonTitleStyle" :xAxis="electricRecordXAxis" :yAxis='electricRecordYAxis' :series='electricRecordSeries' />

        <!--门禁-->
        <common-line style="z-index: 1000;width: 50%;" lineId='guardRecordLine' :height='"5rem"' lineTitle='企业门禁数据' :titleStyle="commonTitleStyle" :xAxis="guardRecordXAxis" :yAxis='guardRecordYAxis' :series='guardRecordSeries' />

        <!--梯控-->
        <common-line style="z-index: 1000;width: 50%;" lineId='liftRecordLine' :height='"5rem"' lineTitle='企业梯控数据' :titleStyle="commonTitleStyle" :xAxis="liftRecordXAxis" :yAxis='liftRecordYAxis' :series='liftRecordSeries' />

        <!--访客-->
        <common-line style="z-index: 1000;width: 50%;" lineId='visitorRecordLine' :height='"5rem"' lineTitle='企业访客数据' :titleStyle="commonTitleStyle" :xAxis="visitorRecordXAxis" :yAxis='visitorRecordYAxis' :series='visitorRecordSeries' />
      </div>
    </div>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import CommonLine from '../../../components/Echarts/Line/commonLine'
  import {api} from '../../api/EnterpriseBigData'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../utils/notice'
  import {pattern} from '../../../utils/regular'
  import {bus} from '../../../utils/bus'
  import echarts from 'echarts'
  import CommonStackingBar from '../../../components/Echarts/Bar/commonStackingBar'

  export default {
    components: {
      CommonStackingBar,
      CommonLine},
    name: 'corporate-portrait',
    data () {
      return {
        enterpriseData: {
          name: '', //住户名称
          represent: '', //法定代表人
          registerMoney: '', //注册资本
          buildDate: '', //成立日期
          status: '', //经营状态
          province: '', //所属省份
          city: '', //所属市区
          region: '', //所属区县
          type: '', //住户类型
          unicomCode: '', //统一社会信用代码

          taxpayerNo: '', //纳税人识别号
          registerNo: '', //注册号
          organizationCode: '', //组织机构代码
          contractPhone: '', //企业公示的联系电话
          otherPhone: '', //企业公示的联系电话（更多号码）
          contributeNum: '', //参保人数
          involve: '', //所属行业
          address: '', //企业公示的地址
          website: '', //企业公示的网址
          email: '', //企业公示的邮箱
          businessScope: '', //经营范围

          electricData: [],
          guardData: [],
          liftData: [],
          visitorData: [],
        },

        commonTitleStyle: {
          color: '#ffffff'
        },

        electricRecordXAxis: {
          type: 'category',
          name: '日期',
          nameTextStyle: {
            color: '#ffffff',
          },
          axisLine:{
            lineStyle:{
              color:'#ffffff',
            }
          },
          data: []
        },
        electricRecordYAxis: [
          {
            type: 'value',
            name: 'kW·h',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
          }
        ],
        electricRecordSeries: [],

        guardRecordXAxis: {
          type: 'category',
          name: '日期',
          nameTextStyle: {
            color: '#ffffff',
          },
          axisLine:{
            lineStyle:{
              color:'#ffffff',
            }
          },
          data: []
        },
        guardRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
          }
        ],
        guardRecordSeries: [],

        liftRecordXAxis: {
          type: 'category',
          name: '日期',
          nameTextStyle: {
            color: '#ffffff',
          },
          axisLine:{
            lineStyle:{
              color:'#ffffff',
            }
          },
          data: []
        },
        liftRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
          }
        ],
        liftRecordSeries: [],

        visitorRecordXAxis: {
          type: 'category',
          name: '日期',
          nameTextStyle: {
            color: '#ffffff',
          },
          axisLine:{
            lineStyle:{
              color:'#ffffff',
            }
          },
          data: []
        },
        visitorRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
          }
        ],
        visitorRecordSeries: [],
      }
    },
    created () {

    },
    mounted () {
      this.getEnterpriseData()
    },
    methods: {
      // 园区企业数据
      getEnterpriseData () {
        this.$axios.post(`${api.getParkEnterpriseById}/${this.$route.params.id}`, {})
          .then(res => {
            let data = res.data.data
            this.enterpriseData = data

            // 电控
            let electricRecordSeries = []
            let electricRecordXAxisData = []
            data.electricData.map(v => {
              electricRecordSeries.push(v.data)
              electricRecordXAxisData.push(v.time)
            })
            this.electricRecordXAxis.data = electricRecordXAxisData
            this.electricRecordSeries = {
              name: '',
              type: 'line',
              stack: '统计',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#0084FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#0084FF'
                }, {
                  offset: 1,
                  color: '#07295A'
                }])
              },
              data: electricRecordSeries
            }

            // 门禁
            let guardRecordSeries = []
            let guardRecordXAxisData = []
            data.guardData.map(v => {
              guardRecordSeries.push(v.data)
              guardRecordXAxisData.push(v.time)
            })
            this.guardRecordXAxis.data = guardRecordXAxisData
            this.guardRecordSeries = {
              name: '',
              type: 'line',
              stack: '统计',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#0084FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#0084FF'
                }, {
                  offset: 1,
                  color: '#07295A'
                }])
              },
              data: guardRecordSeries
            }

            // 梯控
            let liftRecordSeries = []
            let liftRecordXAxisData = []
            data.liftData.map(v => {
              liftRecordSeries.push(v.data)
              liftRecordXAxisData.push(v.time)
            })
            this.liftRecordXAxis.data = liftRecordXAxisData
            this.liftRecordSeries = {
              name: '',
              type: 'line',
              stack: '统计',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#0084FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#0084FF'
                }, {
                  offset: 1,
                  color: '#07295A'
                }])
              },
              data: liftRecordSeries
            }

            // 访客
            let visitorRecordSeries = []
            let visitorRecordXAxisData = []
            data.visitorData.map(v => {
              visitorRecordSeries.push(v.data)
              visitorRecordXAxisData.push(v.time)
            })
            this.visitorRecordXAxis.data = visitorRecordXAxisData
            this.visitorRecordSeries = {
              name: '',
              type: 'line',
              stack: '统计',
              // areaStyle: {},
              smooth:true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#0084FF'
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#0084FF'
                }, {
                  offset: 1,
                  color: '#07295A'
                }])
              },
              data: visitorRecordSeries
            }
          })
          .catch(errorHandler('获取企业数据失败'))
      },
    },
  }
</script>

<style>

</style>
<style scoped lang="less">
  .corporate-portrait {
    height: 100vh;
    min-height: 685px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    position: relative;
    width: 100%;
    color: #FFFFFF;
    font-size: 0.24rem;
    background: url("../../../assets/bg.png");
    background-size: 100% 100%;
    .corporate-portrait-title {
      width: 26%;
      height: 6.3%;
      font-size: 0.48rem;
      /*position: absolute;*/
      /*left: 0;*/
      /*right: 0;*/
      margin: 0 auto;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      #top-marquee {
        display:flex;
        justify-content:center;
        align-items:center;
      }
    }
    .corporate-portrait-main {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      padding: 0.2rem 0.4rem;
      .corporate-portrait-main-left {
        width: 40%;
        height: 100%;
        border: 1px solid #0596D3;
        padding: 0.2rem 0.4rem 0.4rem;
        box-shadow:inset 0px 0px 8px 1px #0596D3;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .corporate-portrait-main-left-table {
          margin-top: 0.2rem;
          flex: 1;
          border: 1px solid #cccccc;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          .corporate-portrait-main-left-table-line {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-top: 1px solid #cccccc;
            .corporate-portrait-main-left-table-line-tip {
              height: 100%;
              width: 2.4rem;
              border-right: 1px solid #cccccc;
              padding: 0.18rem 0;
            }
            .corporate-portrait-main-left-table-line-info {
              height: 100%;
              flex: 1;
              padding: 0.18rem 0.4rem;
              text-align: left;
            }
            .corporate-portrait-main-left-table-line-border-right {
              border-right: 1px solid #cccccc;
            }
          }
        }
      }
      .corporate-portrait-main-right {
        margin-left: 0.4rem;
        padding: 0.2rem 0.4rem;
        flex: 1;
        height: 100%;
        border: 1px solid #0596D3;
        box-shadow:inset 0px 0px 8px 1px #0596D3;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
      }
      .corporate-portrait-main-title-line {
        text-align: center;
        font-size: 0.36rem;
        font-weight: bolder;
        padding: 0 50px 0 30px;
        /*display: flex;*/
        /*justify-content: space-between;*/
      }
    }

    ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px #2DC4BB!important;
      background: #2DC4BB!important;
    }

    ::-webkit-scrollbar-track {/*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px #2DC4BB99!important;
      border-radius: 10px;
      background: #EDEDED;
    }
  }

  @-webkit-keyframes neon2 {
    from {
      text-shadow: none;
      opacity: .3;
    }
    to {
      opacity: 1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/EnterpriseBigData/CorporatePortrait/CorporatePortrait.vue